export default {
  markets: {
    en: 'Markets',
  },
}
